import { createEvent, sample } from 'effector'
import { fx } from '../../../../../libs'
import { RecalcForm } from './types'

export const recalculateBalanceEvent = createEvent<RecalcForm>()
export const recalculateBalance = fx<RecalcForm, void>({
  method: 'POST',
  url: `/finance/wallet/recalculate`,
})

sample({
  clock: recalculateBalanceEvent,
  fn: (recalcData) => {
    return {
      body: {
        ...recalcData,
      },
    }
  },
  target: recalculateBalance,
})
